import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);
`;

export const HitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 48px 28px;
  justify-items: center;

  @media (width >= 48rem) {
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 180px), 1fr));
  }
`;

export const HitsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
`;

export const ShowMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
